import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { SharedConstants } from '@shared/model/shared-constants';
import { EnumModel } from '@shared/model/enum-model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

enum Theme {
  FILL = 'fill',
  OUTLINE = 'outline',
}
@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownMenuComponent),
      multi: true,
    },
  ],
})
export class DropdownMenuComponent implements OnChanges, ControlValueAccessor {
  SharedConstants: SharedConstants;
  isLoading: boolean = true;

  @Input() iconName: string;
  @Input() iconColor: string;
  @Input() dropdownText: string;
  @Input() labelTranslationKey = '';
  @Input() dropdownValue: EnumModel[];

  @Input() selectedValue = SharedConstants.ALL;
  @Input() theme: Theme = Theme.OUTLINE;
  @Output() selectedValueChange = new EventEmitter();

  protected readonly Theme = Theme;

  onChange: any = () => {};
  onTouched: any = () => {};

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  disabled = false;

  writeValue(value: string): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectedValueChange(event: MatSelectChange): void {
    this.selectedValue = event.value;
    this.selectedValueChange.emit(event);
    this.onChange(event.value);
    this.onTouched();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.dropdownValue?.currentValue !== changes?.dropdownValue?.previousValue &&
      Array.isArray(changes?.dropdownValue?.currentValue)
    ) {
      this.isLoading = false;
    }
  }
}
